const Style = {
    backgroundColor: "#f8f8f8",
    textColor: "#424242",
    btcColor: "#f1931b",
};

export default Style;
